module.exports = __webpack_public_path__ + "img/yuyi_JP.19ffba93.jpg";